interface IVideoSurfaceSize {
  width: number
  height: number
}

interface IGetVideoSurfaceSizeParams {
  containerWidth: number
  containerHeight: number
  videoWidth: number
  videoHeight: number
}

const isPositive = (value: number) => Number.isFinite(value) && value > 0

/**
 * Largest rectangle with the video's aspect ratio that fits in the player area.
 * The Android surface uses contentFit="fill" (HET-2339), so it needs the video's
 * aspect ratio to avoid stretching the image (HET-4382).
 */
export function getVideoSurfaceSize({
  containerWidth,
  containerHeight,
  videoWidth,
  videoHeight,
}: IGetVideoSurfaceSizeParams): IVideoSurfaceSize {
  if (!isPositive(containerWidth) || !isPositive(containerHeight)) {
    return { width: 0, height: 0 }
  }

  if (!isPositive(videoWidth) || !isPositive(videoHeight)) {
    return { width: containerWidth, height: containerHeight }
  }

  const scale = Math.min(
    containerWidth / videoWidth,
    containerHeight / videoHeight,
  )

  return { width: videoWidth * scale, height: videoHeight * scale }
}
